import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import {
  appLoaderHeight,
  drawerWidth,
  drawerWidthExpanded,
  drawerWidthExpandedMobile
} from "./consts";

interface ResponsiveDrawerProps {
  children?: React.ReactNode;
  open: boolean;
  small: boolean;
  isMfaSetupLater: boolean; // New parameter added
  onClose?(): void;
}

const useStyles = makeStyles(
  theme => ({
    drawerDesktop: {
      backgroundColor: theme.palette.background.paper,
      border: "none",
      height: `calc(100vh - ${appLoaderHeight + 70}px)`,
      overflow: "visible",
      padding: 0,
      position: "fixed" as "fixed",
      top: (props: ResponsiveDrawerProps) =>
        props.isMfaSetupLater ? "125px" : "80px", // Dynamically set based on isMfaSetupLater
      transition: "width 0.3s ease",
      width: drawerWidthExpanded
    },
    drawerDesktopSmall: {
      overflow: "visible",
      top: (props: ResponsiveDrawerProps) =>
        props.isMfaSetupLater ? "125px" : "80px", // Dynamically set based on isMfaSetupLater
      transition: "width 0.2s ease",
      width: drawerWidth
    },
    drawerMobile: {
      WebkitOverflowScrolling: "auto",
      width: drawerWidthExpandedMobile
    }
  }),
  { name: "ResponsiveDrawer" }
);

const ResponsiveDrawer: React.FC<ResponsiveDrawerProps> = props => {
  const { children, onClose, open, small } = props;

  const classes = useStyles(props);

  return (
    <>
      <Hidden smDown>
        <Drawer
          variant="persistent"
          open
          classes={{
            paper: small ? classes.drawerDesktop : classes.drawerDesktopSmall
          }}
        >
          {children}
        </Drawer>
      </Hidden>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          onClose={onClose}
          open={open}
          classes={{ paper: classes.drawerMobile }}
        >
          {children}
        </Drawer>
      </Hidden>
    </>
  );
};
export default ResponsiveDrawer;
